import { useGtm } from '../useGtm';
import { Order } from '../../../requests/caipirinha-api/interfaces/order.interface';
import { Step as GtmStep } from '../../../requests/caipirinha-api/interfaces/gtm.interface';
import { IPageInfo } from '../useGtm.interface';

export enum Step {
  Resume = '1',
  Payment = '2',
}

export const useCheckoutGtm = () => {
  const {
    getCustomerCard,
    getHitTimestamp,
    getProducts,
    getServices,
    setDataLayer,
  } = useGtm();

  const sendDataToGtm = (
    { details }: Order,
    info: IPageInfo,
    step: GtmStep = Step.Resume,
  ) => {
    const shippingValue = details.shipping
      ? details.shipping.value.toFixed(2)
      : undefined;

    setDataLayer({
      event: 'virtualPageview',
      pageType: info.type || 'checkout',
      pageName: info.name,
      clienteCartao: getCustomerCard(details.payments),
      valorFrete: shippingValue,
      hitTimestamp: getHitTimestamp(),
      totalFrete: shippingValue,
      ecommerce: {
        checkout: {
          actionField: { step },
          products: [
            ...getProducts(details.products),
            ...getServices(details.services),
          ],
        },
      },
    });
  };

  return { sendDataToGtm };
};
